import { useCallback, useMemo } from "react";
import { Flex, Button, Card, Text, Box, Badge, Inset } from "@radix-ui/themes";
import { useParams } from "react-router-dom";
import { CheckIcon } from "@radix-ui/react-icons";
import {
  useCreateNangoIntegration,
  useIntegrations,
} from "@/api/integration/Integration.api";
import SlackCTASVG from "@/routes/onboarding/getting-started/assets/SlackCTASVG";

export function SlackChannelInstallSimulator() {
  const { simulatorId } = useParams<{ simulatorId: string }>();
  const { data: integrations, refetch: reloadIntegrations } = useIntegrations();

  const integrated = useMemo(() => {
    return (integrations ?? []).some(
      (i) => i.type === "CHAT" && i.name === "slack" && i.status === "COMPLETED"
    );
  }, [integrations]);

  const createNangoIntegration = useCreateNangoIntegration({
    reloadIntegrations,
  });

  const handleIntegrateClick = useCallback(() => {
    createNangoIntegration({
      name: "slack",
      type: "CHAT",
    });
  }, [createNangoIntegration]);

  return (
    <Flex align="center" justify="center" style={{ height: "100%" }}>
      <Box maxWidth="350px">
        <Card size="2">
          <Inset clip="padding-box" side="top" pb="current">
            <SlackCTASVG />
          </Inset>

          <Flex direction={"column"} gap={"5px"}>
            <Text size="3" weight={"medium"}>
              Integrate with Slack
            </Text>

            <Text size="1" color="gray">
              Enable your team to 'Ask Quack Anything'—get instant answers,
              insights, and support in Slack.
            </Text>

            <Flex flexGrow={"1"} align={"end"} pt={"20px"}>
              {integrated ? (
                <Badge
                  color={"green"}
                  size={"3"}
                  style={{ height: "32px", paddingInline: "12px" }}
                >
                  <CheckIcon />
                  Integrated
                </Badge>
              ) : (
                <Button
                  color={"gray"}
                  variant={"outline"}
                  size={"2"}
                  highContrast
                  onClick={handleIntegrateClick}
                >
                  Integrate with Slack
                </Button>
              )}
            </Flex>
          </Flex>
        </Card>
      </Box>
    </Flex>
  );
}
